import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accountSelect", "costCentreField"]

  toggle(event) {
    // console.log("toggle " + event)
    const select = event.target
    const selectedOption = select.selectedOptions[0]
    const canHaveCostCentre = (selectedOption.dataset.canHaveCostCentre === "true") || (selectedOption.value === "select")

    const targetName = select.dataset.costCentreToggleTargetId
    if (!targetName) return

    // console.log("  found cost centre target " + targetName)

    const target = this.targets.find(targetName)
    if (target) {
      // console.log("  found it in targets, toggle d-none to " + !canHaveCostCentre)
      target.classList.toggle("invisible-preserve-space", !canHaveCostCentre)
      target.setAttribute("aria-hidden", (!canHaveCostCentre).toString())
    }
  }

  connect() {
    // console.log("connected");
    this.toggle({ target: this.accountSelectTarget })
  }
}
